import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { ChipsMyPublicationsContainerProps } from "../../../../interfaces/containers";
import Chips from "../../../../pages/Profile/MyPublications/EntryPoint/Chips";
import { setStatesMyPublications, setBranchesMyPublications, setYearsMyPublications, setSellersMyPublications, setSearchMyPublications } from "../../../../actions/myPublications";

function mapStateToProps(state: ChipsMyPublicationsContainerProps) {
    return{
        filters: state.profile.myPublications.filters
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        setStatesMyPublications,
        setBranchesMyPublications,
        setYearsMyPublications,
        setSellersMyPublications,
        setSearchMyPublications
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Chips);